import logo from './logo.svg';
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { UserProvider } from "./contexts/UserContext"
import { LoaderProvider } from './contexts/LoaderContext';
import PrivateRoutes from './contexts/PrivateRoutes';
import { RouteChangeLoader } from './lib/RouteChangeLoader';
import Layout from './layouts';

import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import SignUp_SuccessPage  from './pages/auth/SuccessPage';

import Dashboard from './pages/dashboard';

/* Workshops */
import Workshops from "./pages/workshops/Index.tsx"
import NaiveBayes from './pages/workshops/NaiveBayes';
import DecisionTree from './pages/workshops/DecisionTree';

/* Accounts */
import Profile from './pages/accounts/profile/profile';

// Feature Pages
import Redirect from './pages/features/redirect';
import BudgetPlanner from './pages/features/budget-planner/Index';
import BudgetPlannerSettings from './pages/features/budget-planner/Settings';
import CashFlows from './pages/features/budget-planner/cash-flow/Index';

import { AlertProvider } from './contexts/AlertContext';
function App() {
  return (
    <AuthProvider>
      <LoaderProvider>
        <AlertProvider>      
        <Router>
          <RouteChangeLoader/>
          <UserProvider>
          <Routes>
            <Route path='/signin' element={<SignIn/>}/>
            <Route path='/signup' element={<SignUp/>}/>
            <Route path='/signUp/success' element={<SignUp_SuccessPage/>}/>
            
          {/* Protected Routes */}
            <Route element={<PrivateRoutes/>}>
                <Route path="/" element={<Layout />}>
                  <Route path='/' element={<Dashboard/>} />

                  <Route  path='/workshops'>
                    <Route index element={ <Workshops/>}></Route>
                    <Route path='naive-bayes' element={<NaiveBayes/>}></Route>
                    <Route path='decision-tree' element={<DecisionTree/>}></Route>
                  </Route>

                  <Route path='/features'>
                    <Route path='budget-planner'>
                      <Route index element={<BudgetPlanner/>}></Route>
                      <Route path='settings' element={<BudgetPlannerSettings/>}></Route>
                      <Route path='cash-flows' element={<CashFlows/>}></Route>
                    </Route>
                  </Route>

                  <Route path='/profile' element={<Profile/>}></Route>

                </Route>
            </Route>
          </Routes>
          </UserProvider>
        </Router>
        </AlertProvider>
      </LoaderProvider>
    </AuthProvider>
    
  );
}

export default App;
